import icon from 'assets/img/icons/special-offers.svg'

const PlaceholderBlock = ({ img = icon, title = 'No cards available', info }) => {
  return (
    <section className="placeholder-block">
      <img src={img} alt="placeholder icon" className="placeholder-block__icon" />
      <h5 className="placeholder-block__title">{title}</h5>
      {
        info && <p className="placeholder-block__info">{info}</p>
      }
    </section>
  )
}

export default PlaceholderBlock;
